/* ============================================================
   Revam Search Form (GTG-013) — base custom element for native
   predictive search. Ported from Dawn's search-form.js, self-contained
   (bundles debounce so it needs no theme global.js).
   ============================================================ */
(function () {
  if (window.RevamSearchForm) return;

  function debounce(fn, wait) {
    let t;
    return function () {
      const ctx = this;
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(() => fn.apply(ctx, args), wait);
    };
  }
  window.revamDebounce = debounce;

  class RevamSearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resetButton = this.querySelector('button[type="reset"]');

      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.addEventListener(
          'input',
          debounce((event) => this.onChange(event), 300).bind(this)
        );
      }
    }

    toggleResetButton() {
      if (!this.resetButton) return;
      const resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) {
        this.resetButton.classList.remove('hidden');
      } else if (this.input.value.length === 0 && !resetIsHidden) {
        this.resetButton.classList.add('hidden');
      }
    }

    onChange() {
      this.toggleResetButton();
    }

    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a');
    }

    onFormReset(event) {
      event.preventDefault();
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }
  }

  window.RevamSearchForm = RevamSearchForm;
  if (!customElements.get('revam-search-form')) {
    customElements.define('revam-search-form', RevamSearchForm);
  }
})();
